'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Slot } from './slot.js';
export const CopilotHeader = forwardRef(function CopilotHeader({ asChild, className, ...rest }, ref) {
    const Comp = asChild ? Slot : 'div';
    return (_jsx(Comp, { ref: ref, className: ['copilot-header', className].filter(Boolean).join(' '), ...rest }));
});
export const CopilotTitle = forwardRef(function CopilotTitle({ asChild, className, ...rest }, ref) {
    const Comp = asChild ? Slot : 'h2';
    return (_jsx(Comp, { ref: ref, className: ['copilot-title', className].filter(Boolean).join(' '), ...rest }));
});
//# sourceMappingURL=header.js.map